import anime from 'animejs';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import cookie from 'js-cookie';
import {
	duration,
	queryFocusable,
	makeCallback,
	releaseFocus,
	trapFocus,
} from './utilities';

/**
 * Callback stuff
 */

const callbacks = makeCallback<string>();
const immediateCallbacks = makeCallback<string>();

const onAgeChecked = callbacks.add;
const onAgeCheckedImmediate = immediateCallbacks.add;
export { onAgeChecked, onAgeCheckedImmediate };

/**
 * Compare dates
 */

const checkAgeElements = (
	limit: number,
	year: HTMLSelectElement | null,
	month: HTMLSelectElement | null,
	day: HTMLSelectElement | null,
) => {
	return checkAge(limit, year?.value, month?.value, day?.value);
};

const checkAge = (
	limit: number,
	year?: string,
	month?: string,
	day?: string,
) => {
	// Year needs to be provided. Month and day are accepted if they are undefined
	// (fields not available on the page) but rejected if they are '' (fields available
	// without a set value).
	if (!year || month === '' || day === '') {
		return false;
	}

	const yearN = Number(year);
	const monthN = Number(month || 0);
	const dayN = Number(day || 1);
	// Default to January 1

	if (isNaN(yearN) || isNaN(monthN) || isNaN(dayN)) {
		return false;
	}

	const earliest = new Date();
	earliest.setFullYear(earliest.getFullYear() - limit);

	const provided = new Date(yearN, monthN - 1, dayN);

	return provided.getTime() < earliest.getTime();
};

window.addEventListener('DOMContentLoaded', () => {
	const el = document.querySelector<HTMLElement>('[data-age-check]');
	const content = el?.querySelector('.age-check__content');
	const form = el?.querySelector<HTMLFormElement>('[data-age-check-form]');

	const age_check = cookie.get('checked_age');
	if (!el || !form || age_check == 'yes') {
		immediateCallbacks.invoke(age_check || '');
		callbacks.invoke(age_check || '');
		el?.parentElement?.removeChild(el);
		return;
	}

	/**
	 * Set up the age check
	 */
	disableBodyScroll(el);
	trapFocus(el);

	let ageLimit = Number(el.getAttribute('data-age-check-limit'));
	if (isNaN(ageLimit)) {
		ageLimit = 20;
	}

	const year = form.querySelector<HTMLSelectElement>('#year');
	const month = form.querySelector<HTMLSelectElement>('#month');
	const day = form.querySelector<HTMLSelectElement>('#day');
	const remember = form.querySelector<HTMLInputElement>('#remember');
	const submit = form.querySelector<HTMLInputElement>('input[type="submit"]');

	if (submit) {
		submit.disabled = !checkAgeElements(ageLimit, year, month, day);
	}

	form.addEventListener('change', () => {
		const validAge = checkAgeElements(ageLimit, year, month, day);
		if (submit) {
			submit.disabled = !validAge;
		}
	});

	form.addEventListener('submit', (ev) => {
		ev.preventDefault();

		const validAge = checkAgeElements(ageLimit, year, month, day);
		if (validAge) {
			const attrs: cookie.CookieAttributes = {
				path: '/',
			};

			if (remember?.checked) {
				attrs.expires = 30;
			}

			cookie.set('checked_age', 'yes', attrs);
			immediateCallbacks.invoke('yes');

			const timeline = anime.timeline({
				easing: 'cubicBezier(.6,.02,.92,.73)',
				complete() {
					releaseFocus(el);
					enableBodyScroll(el);
					el.parentNode?.removeChild(el);
				},
			});

			timeline.add(
				{
					targets: content,
					opacity: 0,
					duration: duration(400),
					scale: 0.85,
				},
				0,
			);

			timeline.add(
				{
					targets: el,
					opacity: 0,
					duration: duration(400),
				},
				250,
			);

			window.setTimeout(() => {
				callbacks.invoke('yes');
			}, 500);
		}
	});
});
